
/**
 * Event file viewer component
 */
import {
  AfterContentInit,
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  OnChanges, OnDestroy,
  OnInit,
  SimpleChanges
} from '@angular/core';
import {EventService} from '@ispm-client/modules/events/services/event.service';
import {get, set, remove, findIndex, find,includes,cloneDeep, unionBy, isEmpty } from 'lodash';
import {IspmHttpClient} from '@ispm/core/services/ispm-http-client';
import {Observable,Subject} from 'rxjs';
import { filter } from 'rxjs/operators';
import {FormHandlerService} from '@ispm/dynamic-form/services/form-handler.service';
import {modalResponse} from '@ispm/layout/constants/modal-responses.enum';
import {IEvent, IEventDefinition} from '@ispm-client/modules/events/Interfaces';
import {FileService} from '@ispm-client/modules/file-module/services/file.service';
import {ConfirmModalLoaderPayload} from '@ispm/layout/classes/confirm-modal-loader-payload';
import {ModalLoaderNgjsService} from '@ispm/layout/services/modal-loader-ngjs.service';
import {CoreActionCreatorService} from '@ispm/core/services/core-action-creator.service';
import {INLPHighlightConfig} from '@ispm-client/modules/file-module/Interfaces';
import {NOTIFICATION_MESSAGE} from "@ispm-client/modules/aggregator/services/consts";
import {MultiFileParsingService} from "@ispm-client/modules/file-module/services/multi-file-parsing.service";
import {EventValidationWizardService} from "@ispm-client/modules/events/services/event-validation-wizard.service";
import has = Reflect.has;
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';
import {RichTextUtils} from "@ispm/shared/classes/RichTextUtils";
import {StringUtils} from "@ispm/shared/utils/String.utils";

@Component({
  selector: 'ispm-event-content-file-viewer',
  templateUrl: './event-content-file-viewer.component.html',
  styleUrls: ['./event-content-file-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EventContentFileViewerComponent implements OnInit, OnChanges,OnDestroy, AfterViewInit, AfterContentInit {
  prettyFileList: any = [];
  selectedEventFile: any;
  private componentDestroyer: Subject<any> = new Subject();
  selectedFileContent: Observable<any>;
  @Input() selectedEvent: IEvent;
  @Input() reviewExtractionKey: boolean = false;
  fileExtension: string = '*';
  uploadInProgress: boolean;
  hasNLPHighLights: boolean = false;
  nlpTransformed: any;
  @Input() eventFileIdList: any
  @Input() nlpConfig: INLPHighlightConfig;
  @Input() addReportAvailable: boolean = true;
  @Input() isEditable: boolean = false;
  @Input() eventDefinition: IEventDefinition;
  @Input() findingData: any = [];
  videoFileReferences:any=[];
  imageFileReferences:any=[];
  dicomVideoReferences:any=[];
  dicomImageReferences:any=[];
  mergedVideoReferences:any=[];
  mergedImageReferences:any=[];
  showPanes:number =1;
  maxFileSize:number=0;
  totalFileCount:number=0;
  maxFileCount:number=0;
  isExternalFile: boolean = false;
  isAddButtonDisable:boolean;
  selectedEventNlpType: string = null;

  constructor(private _eventService: EventService,
              private _ispmHttpClient: IspmHttpClient,
              private changeDetector: ChangeDetectorRef,
              private _formHandlerService: FormHandlerService,
              private _fileService: FileService,
              private notificationMessageService: NotificationMessageService,
              private notificationMessage: NOTIFICATION_MESSAGE,
              private _modalLoaderService: ModalLoaderNgjsService,
              private _multiFileParsingService: MultiFileParsingService,
              private coreAC: CoreActionCreatorService,
              private eventWizardService: EventValidationWizardService) {
  }

  ngOnInit() {
    const fileOptions = this._fileService.getFileUploadOptions();
    const supportedFiles = get(fileOptions, 'fileExtension');
    if (supportedFiles && supportedFiles.length > 0) {
      this.fileExtension = supportedFiles.join(',');
    }
  }

  ngAfterViewInit(): void {

  }
  ngAfterContentInit(): void {
    this._eventService.setIsButtonDisable(this.isAddButtonDisable);
    this._eventService.getSelectedEvent().takeUntil(this.componentDestroyer.asObservable()).pipe(filter((event) => !isEmpty(event))).subscribe(event => {
      if(get(event,'nlpFindings') !== undefined && get(event,'nlpFindings').length>0){
        this.isAddButtonDisable = true;
        const nlpType = get(event, 'nlpType');
        if(!isEmpty(nlpType) && Array.isArray(nlpType)) {
          this.selectedEventNlpType = get(event, 'nlpType[0].code', null);
        } else {
          this.selectedEventNlpType = get(event, 'nlpType.code', null);
        }
      }
    })
  }
  ngOnDestroy(): void {
    this.isAddButtonDisable =false;
    this.componentDestroyer.next();
    this.componentDestroyer.complete();
  }
  private checkAddButton(flag:boolean): boolean{
    this._eventService.setIsButtonDisable(flag);
    this.isAddButtonDisable = flag;
    this._eventService.getSelectedEvent().subscribe(event => {
      if(event !== null &&
          has(event,'nlpFindings') &&
          get(event,'nlpFindings') !== undefined &&
          get(event,'nlpFindings').length>0
      ){
        this.isAddButtonDisable = true;
      }
    })
    return this.isAddButtonDisable;
  }
  /**
   * Set selected file to display on file viewer
   * @param _selectedEventFile
   */
  onChangeFile(_selectedEventFile: any) {
    if(_selectedEventFile==='openImages'){
      this.showPanes=2;
    } else if(_selectedEventFile==='openVideos'){
      this.showPanes=3;
    }
    else if (this.selectedEventFile && (this.selectedEventFile.id !== _selectedEventFile.id || (_selectedEventFile.isExternal && _selectedEventFile.resourceType==="DICOM"))) {
      this.showPanes=1;
      this.selectedEventFile = _selectedEventFile;
      this.getFileContent(this.selectedEventFile);
      this._eventService.setCurrentActiveFile(this.selectedEventFile);
      this.changeDetector.markForCheck();
    }
  }

  /**
   * get file content by file reference id
   * @param fileId: string
   */
  getFileContent(file: any) {
    if (get(this.selectedEventFile, 'nlpReference') && this.checkToShowNLPHighlights()) {
      this.hasNLPHighLights = true;
      this.nlpTransformed = get(this.selectedEventFile, 'nlpFindings.documents[0]');
      this.eventWizardService.setNLPHighlights(this.nlpTransformed);
      // if (get(this.nlpConfig, 'basedOnTransformations')) {
      return;
      // }
    } else {
      this.hasNLPHighLights = false;
    }
    if (file.resourceType === 'DICOM') {

      let patientId: String = null;
      let studyId: String = null;
      const context: any = get(this.selectedEvent, 'context');
      context.forEach(contxt => {
        if(contxt.resourceType === 'Patient') {
          patientId = contxt.reference;
        }
        if(contxt.resourceType === 'StudyInstanceUid') {
          studyId = contxt.reference;
        }
      });
      this.selectedFileContent = this._multiFileParsingService.getFileFromWADOUrl(file, studyId, patientId);
    } else {
      this.selectedFileContent = this._eventService.getFileFromCache(file.id);
    }
  }

  /**
   * Get file list with pretty information
   */
  getFileListWithMetaInformation() {
    this.prettyFileList.length = 0;
    this.imageFileReferences=[];
    this.dicomImageReferences=[];
    this.videoFileReferences=[];
    this.dicomVideoReferences=[];
    if (this.eventFileIdList && this.eventFileIdList.length > 0) {
       this.totalFileCount = this.eventFileIdList.length;
      const queries = [];
      let filesListToDownload= [];
      this.eventFileIdList.forEach( function(file, index) {
        let nlpFindings = get(this.selectedEvent, 'nlpFindings');
        if (nlpFindings && nlpFindings.length > 0 && this.nlpConfig) {
          let nlpRefFile = find(nlpFindings, function (nlpRef) {
            return get(nlpRef, 'fileReference') === get(file, 'reference');
          });
          this.eventFileIdList[index] = {...this.eventFileIdList[index], ...{'nlpReference':get(nlpRefFile, 'nlpReference')}};
          file = {...file, ...{'nlpReference':get(nlpRefFile, 'nlpReference')}};
        }
        if (get(file, 'nlpReference') && this.checkToShowNLPHighlights()) {
          queries.push({
            'targetResource': get(file, 'nlpReference.resourceType'),
            'queryString': `_id=${get(file, 'nlpReference.reference')}`
          });
        }
        if(get(file,'resourceType')==="DICOM") {
          this.dicomImageReferences = this.eventFileIdList.filter(item => get(item, 'fileType') === 'image' && get(item, 'resourceType') === 'DICOM');
          this.dicomVideoReferences = this.eventFileIdList.filter(item => get(item, 'fileType') === 'video' && get(item, 'resourceType') === 'DICOM');
          this.prettyFileList = this.eventFileIdList.filter(item => get(item, 'fileType') === 'pdf' && get(item, 'resourceType') === 'DICOM');
          if (get(file, 'fileType') === 'pdf' && get(file, 'resourceType') === 'DICOM') {
            this.eventFileIdList[index].isExternalFile = true;
          }
        }
        else {
          filesListToDownload.push(file);
          queries.push({
            'targetResource': get(file, 'resourceType'),
            'queryString': `_id=${get(file, 'reference')}`
          });
        }
      }.bind(this));
      this._eventService.getAllFilesAndCache(filesListToDownload);
      let fileResSub = this._ispmHttpClient.post('bundleUtil/search', { queries}).subscribe(val => {
        const fileList = [];
        fileResSub.unsubscribe();
        if (val && val.length > 0) {
          val.forEach((fileMeta, index) => {
            let fileData = get(fileMeta, 'response.entry[0].resource');
            if( fileData && get(this.eventDefinition, 'ui.eventPanel.gallery.showAsGallery')) {
              if (includes(['gif', 'png', 'jpeg', 'tiff', 'jpg'], fileData.fileType.toLowerCase())) {
                if(!find(this.imageFileReferences,(obj)=>{return obj.id===fileData.id})) {
                  this.imageFileReferences.push({...fileData, ...this.eventFileIdList[index]});
                  this.showPanes = 2;

                }
              } else if (includes(['mp4', 'mov', 'avi', 'flv'], fileData.fileType.toLowerCase())) {
                if(!find(this.videoFileReferences,(obj)=>{return obj.id===fileData.id})) {
                  this.videoFileReferences.push({...fileData, ...this.eventFileIdList[index]});
                  this.showPanes = 3;
                }
              }
              else{
                if(fileData && get(this.eventFileIdList, `[${index}].reference`)) {   // TODO This will fail when we have multiple nlp reports in same event need to refactor
                  fileData['id'] = get(this.eventFileIdList, `[${index}].reference`)
                  fileList.push({...fileData, ...this.eventFileIdList[index]});
                  this.showPanes = 1;
                }
              }
            }
            else {
              if(fileData && get(this.eventFileIdList, `[${index}].reference`)) {   // TODO This will fail when we have multiple nlp reports in same event need to refactor
                fileData['id'] = get(this.eventFileIdList, `[${index}].reference`)
                fileList.push({...fileData, ...this.eventFileIdList[index]});
              }
            }
          });
        }
        if(this.dicomImageReferences)
          this.showPanes=2;
        if(this.dicomVideoReferences)
          this.showPanes=3;

        this.mergedImageReferences=[].concat(this.imageFileReferences,this.dicomImageReferences);
        this.mergedVideoReferences=[].concat(this.videoFileReferences,this.dicomVideoReferences);
        if ( fileList.length > 0) {
          this.prettyFileList = unionBy(this.prettyFileList, fileList, 'id' );
        }
        if (!this.selectedEventFile && (this.prettyFileList && this.prettyFileList.length > 0)) {
          this.selectedEventFile = this.prettyFileList[0];
          this._eventService.setCurrentActiveFile(this.selectedEventFile);
          this.getFileContent(this.selectedEventFile);
        }
        this.changeDetector.markForCheck();
        this.changeDetector.detectChanges();
      });

    } else {
      this.selectedEventFile = null;
      this.changeDetector.markForCheck();
      this.changeDetector.detectChanges();
    }
  }

  /**
   * Upload file to event
   */
  onUploadInput(event) {
    if (event.target && event.target.files) {
      if (StringUtils.isInvalidCharsInFileName(event.target.files[0].name)) {
        this.notificationMessageService.error(`${this.notificationMessage.FILENAME_CONTAINS_HTML}`);
        return;
      }
      const file: File = event.target.files[0];
      const fileType = file.type;
      const notAllowedFileExtension = get(this.eventDefinition, 'ui.eventPanel.gallery.uploads.notAllowedExtensions', undefined);
      this.maxFileSize = get(this.eventDefinition, 'ui.eventPanel.gallery.uploads.maxUploadSize');
      this.maxFileCount = get(this.eventDefinition, 'ui.eventPanel.gallery.uploads.maxUploadCount');
      if (!this.maxFileCount || this.totalFileCount < this.maxFileCount) {
        if (!this.maxFileSize || file.size <= this.maxFileSize) {
          if (!this.fileExtension ||
            (this.fileExtension && (this.fileExtension === '*' || this.fileExtension.split(',').includes(`.${file.name.split('.')[1].toLowerCase()}`)))) {
            if (Array.isArray(notAllowedFileExtension) && !notAllowedFileExtension.includes(fileType)) {
              this.coreAC.setLoader(true);
              this._fileService.uploadFile(file).subscribe(response => {
                  this.coreAC.setLoader(false);
                  if (get(response, 'body.referenceId')) {
                    this.prepareEventContentAndUpdate(get(response, 'body'));
                  }
                },
                error => {
                });
            } else if (!notAllowedFileExtension) {
              this.coreAC.setLoader(true);
              this._fileService.uploadFile(file).subscribe(response => {
                  this.coreAC.setLoader(false);
                  if (get(response, 'body.referenceId')) {
                    this.prepareEventContentAndUpdate(get(response, 'body'));
                  }
                },
                error => {
                });
            } else {
              this.notificationMessageService.error(`${this.notificationMessage.CANNOT_UPLOAD_FILE_EXPECTED_EXTENSION}  ${this.fileExtension}`);
            }
          } else {
            this.notificationMessageService.error(`${this.notificationMessage.CANNOT_UPLOAD_FILE_EXPECTED_EXTENSION}  ${this.fileExtension}`);
          }
        } else {
          this.notificationMessageService.error(`${this.notificationMessage.CANNOT_UPLOAD_FILE_SIZE_EXCEEDS}  ${this.maxFileSize}`);
        }
      } else {
        this.notificationMessageService.error(`${this.notificationMessage.CANNOT_UPLOAD_FILE_MAXIMUM_THRESHOLD_REACHED}  ${this.maxFileCount}`);
      }
    }
    event.preventDefault();
  }




  /**
   * prepare event content  to update
   */
  prepareEventContentAndUpdate(fileData) {
      const content: any = get(this.selectedEvent, 'content');
      const fileInfo = { contentType: 'file', resourceType: 'FileResource'};
      set(fileInfo, 'reference', get(fileData, 'referenceId'));
      set(fileInfo, 'name', get(fileData, 'name'));
      content.push(fileInfo);
      this._eventService.updateEvent(this.selectedEvent.id, this.selectedEvent).subscribe(data => {
        this.notificationMessageService.success(this.notificationMessage.FILE_UPLOADED_AND_ATTACHED_SUCCESSFULLY);
        this.selectedEvent = data;
        this.eventFileIdList = [];
        this.selectedEvent.content.forEach(content=>{
          if(content.contentType.toLowerCase()==='file')
            this.eventFileIdList.push(content)
        });

    this.getFileListWithMetaInformation();
    });
  }

  /**
   * Delete file from event
   */
  deleteReport(file) {
    this._modalLoaderService.popupModal('confirm',
      ConfirmModalLoaderPayload.builder()
        .setTitle('Delete File')
        .setContent(`Are you sure want to delete ${file.friendlyName} file?`)
        .setApproveButtonText('Confirm')
        .setDeclineButtonText('Cancel'),
      'ALERT'
    ).subscribe((response: modalResponse) => {
      if (get(response, 'payload') === modalResponse.approve) {
        const content: any = get(this.selectedEvent, 'content');
        remove(content, item => {
          return get(item, 'reference') === get(file, 'id');
        });
        this._eventService.updateEvent(this.selectedEvent.id, this.selectedEvent).subscribe(data => {
          this.notificationMessageService.success(this.notificationMessage.FILE_DELETED_SUCCESSFULLY);
          this.selectedEvent = data;
        });
      }
    });
  }

  /**
   *
   */
  checkToShowNLPHighlights() {
    let showNLPHighLights = false;
    let nlpFindings = get(this.selectedEvent, 'nlpFindings');
    if (nlpFindings && nlpFindings.length > 0 && this.nlpConfig) {
      let nlpTypeIndex = findIndex(nlpFindings, function (nlpFinding) {
        return (get(this.nlpConfig, 'nlpType', []).includes(get(nlpFinding, 'nlpType.code'))) && get(nlpFinding, 'nlpPositiveFindings');
      }.bind(this));
      showNLPHighLights = nlpTypeIndex > -1 ? true : false;
    }
    return showNLPHighLights;
  }


  /**
   * Download file directly using blob
   */
  public downloadFileWithBlob(file) {
    this._eventService.getFileFromCache(get(file, 'id')).subscribe(data => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(this._fileService.getBlob(data));
      a.download = get(file, 'name');
      a.click();
      this.changeDetector.markForCheck();
    });
  }

  /**
   *
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'eventFileIdList':
            this.selectedEventFile = null;
            this.getFileListWithMetaInformation();
            break;
          case 'nlpConfig':
            this.checkToShowNLPHighlights();
            break;
          case 'selectedEvent':
            this.mergedVideoReferences=[];
            this.mergedImageReferences=[];
            break;
        }
      }
    }
  }

  escapeLabel(label: string): string {
    return StringUtils.escapeHtml(label);
  }
}
